/*
* Copyright (C) Regione Lombardia
*/
import { Pipe, PipeTransform } from '@angular/core';
import { AnagraficaMacroTipologiaOpera } from '@models';

@Pipe({
    name: 'anagraficaMacroTipologiaOpera',
})
export class AnagraficaMacroTipologiaOperaPipe implements PipeTransform {

    transform(value: number, items: AnagraficaMacroTipologiaOpera[]) {
        return items.find(i => i.id === value)?.descrizione || '';
    }

}
